import { observer } from "mobx-react-lite";
import { useParams } from "react-router-dom";
import usePlaygroundSession from "./hooks/usePlaygroundSession";
import { usePlayground } from "./playground-store";
import PlaygroundCore from "./PlaygroundCore";
import PlaygroundShimmer from "./PlaygroundShimmer";
import { PlaygroundDialogStoreProvider } from "./PlaygroundDialog/playground-dialog-store";
import { GoogleReCaptchaProvider } from "@/providers/GoogleReCaptchaProvider";

const PlaygroundWithSession = () => {
  const { sessionId } = useParams();
  const playground = usePlayground();
  usePlaygroundSession();
  return playground.isPendingSessionInitialization || !sessionId ? (
    <PlaygroundShimmer />
  ) : (
    <GoogleReCaptchaProvider showDisclaimer={false}>
      <PlaygroundDialogStoreProvider>
        <PlaygroundCore />
      </PlaygroundDialogStoreProvider>
    </GoogleReCaptchaProvider>
  );
};

export default observer(PlaygroundWithSession);
